import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import * as AdminModels from '../../models/AdminModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useEmailUserCapacityQuery({
	impersonationContext,
	enabled = true,
}: {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () =>
			userSession.webServiceHelper.callAsync<AdminModels.IEmailCapacity>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'email/user/capacity',
					impersonationContext,
				}),
				'GET'
			),
		queryKey: ['email/user/capacity', impersonationContext],
	});
}
